import { EntityState, PayloadAction } from '@reduxjs/toolkit';

import { cloneDeep } from 'lodash';

import { CompPropertyDataState, PropertyDataState, SubjectPropertyDataState } from '../../types.ts';
import { propertyDataAdapter } from '../propertyDataAdapter.ts';
import { getBumpedSyncState } from '../utils/getBumpedSyncState.ts';

export const setPropertyDataReducer = (
  state: EntityState<PropertyDataState, string>,
  action: PayloadAction<PropertyDataState>,
) => {
  const { id } = action.payload;

  const current = state.entities[id];
  if (!current) return;

  const clonedPropertyData = cloneDeep(action.payload);
  const syncState = getBumpedSyncState(current.syncState);

  const changes: Partial<PropertyDataState> = { id, syncState };
  if (id === 'subject') {
    (changes as SubjectPropertyDataState).subjectData = (
      clonedPropertyData as SubjectPropertyDataState
    ).subjectData;
  } else {
    changes.compData = (clonedPropertyData as CompPropertyDataState).compData;
  }

  propertyDataAdapter.updateOne(state, { id, changes });
};
